(function(document) {

    let selectors = {
        productCards: '.product-card'
        
    };
  
    let productCards = document.querySelectorAll(selectors.productCards);

    // Locale root (es. "" sulla lingua primaria, "/ja" o "/en" sulle secondarie).
    // Serve a chiamare l'endpoint .js nella STESSA lingua della pagina, altrimenti
    // option1/option2 tornano nella lingua di default e non combaciano con attr-value.
    let LOCALE_ROOT = (window.__shopLocaleRoot || '/').replace(/\/+$/, '');

    productCards.forEach(function(productCard){

        let product_handle = productCard.getAttribute("attr-handle")
        jQuery.getJSON(LOCALE_ROOT+'/products/'+product_handle+'.js', function(productSel) {

            if (productSel) {

                let variant_title = productCard.getAttribute("attr-variant-title")
                let squareSizes = productCard.querySelectorAll(".variations-sizes .square-size")
                productSel.variants.forEach(function(productSelVariants){
                    let variant_title_split = variant_title.split(" / ")
                    if (variant_title_split[0] == productSelVariants.option1) {

                        squareSizes.forEach(function(squareSize){
                            let squareSizeValue = squareSize.getAttribute("attr-value")
                            
                            if (productSelVariants.option2 == squareSizeValue) {

                                squareSize.classList.add("exist")
                                if (productSelVariants.available == false) {
                                    squareSize.classList.add("sold-out")
                                } else {
                                    squareSize.classList.remove("sold-out")
                                }
                            }
                        })
                    }
                })
            } else {
                console.log(product_handle + " not found")
            }

        })
    })

})(document);
  